import Vue from '@/main'
import i18n from '@/plugins/i18n'

const state = {
  account: "",
  navigationDrawer: true,
  notification: {
    show: false,
    success: true,
    message: ''
  },
  playerLangs: ['fr', 'en', 'es', 'ru', 'de'],
  adminLangs: ['fr', 'en', 'es', 'de'],
}

const getters = {
  playerLangs: state => state.playerLangs,
  
  adminLangs: state => state.adminLangs,
  
  appName: () => i18n.t('general.name'),

  account: state => {
    return state.account
  },

  filteredMenu: (state, getters, rootState, rootGetters) => {
    return [
      {
        title: i18n.t('menu.home'),
        icon: "home",
        link: "/",
        children: [],
        home: false,
        roleRequire: 1
      },
      {
        title: i18n.t('menu.games'),
        icon: "videogame_asset",
        link: "/games",
        children: [],
        home: true,
        roleRequire: 1
      },
      {
        title: i18n.t('menu.gameVersions'),
        icon: "list",
        link: "/game-versions",
        children: [],
        home: true,
        roleRequire: 3
      },
      {
        title: i18n.t('menu.demandProfiles'),
        icon: "timeline",
        link: "/demand-profiles",
        children: [],
        home: true,
        roleRequire: 2
      },
      {
        title: i18n.t('menu.instructions'),
        icon: "info",
        link: "/instructions",
        children: [],
        home: true,
        roleRequire: 3
      },
      {
        title: i18n.t('menu.params'),
        icon: "payment",
        link: "/tokens",
        children: [],
        home: true,
        roleRequire: 2
      },
      {
        title: i18n.t('menu.users'),
        icon: "supervisor_account",
        link: "/users",
        children: [],
        home: true,
        roleRequire: 2
      },
      {
        title: i18n.t('menu.profile'),
        icon: "account_circle",
        link: "/profile",
        children: [],
        home: true,
        roleRequire: 1
      }
    ].filter((item) => item.roleRequire <= rootGetters['user/roleLevel'])
  }
}

const actions = {
  changeLang (undefined, lang) {
    Vue.$i18n.locale = lang
    Vue.$vuetify.lang.current = lang
  }
}

const mutations = {
  SET_notification (state, {success, message}) {
    state.notification.show = true
    state.notification.success = success
    state.notification.message = message
  },
  UNSET_notification (state) {
    state.notification.show = false
    state.notification.message = ''
  },
  SET_navigationDrawer (state, val) {
    state.navigationDrawer = val
  },
  SET_account (state, val) {
    state.account = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}